export default __webpack_public_path__ + "static/SizePresets-2fe404893ff6b91bb1695eb39ee9a658.png";